// extracted by mini-css-extract-plugin
export default {"permissionEditorPageContainer":"_permission-editor-page_permissionEditorPageContainer__Qxi2X"};